export default "__VITE_ASSET__CbSa19Xi__"